import { Organism } from './organism'
import { Food } from './food'

const INITIAL_ORGANISMS = 120
const INITIAL_FOOD = 80
const MAX_FOOD = 200
const FOOD_SPAWN_INTERVAL = 0.5  // 秒
const MIN_ORGANISMS = 20
const REPRODUCTION_ENERGY = 130
const REPRODUCTION_COST = 50

export class World {
  width: number
  height: number
  organisms: Organism[]
  foods: Food[]

  private foodTimer = 0
  tick = 0

  constructor(width: number, height: number) {
    this.width = width
    this.height = height
    this.organisms = []
    this.foods = []
    this.init()
  }

  private init(): void {
    for (let i = 0; i < INITIAL_ORGANISMS; i++) {
      this.organisms.push(new Organism(
        Math.random() * this.width,
        Math.random() * this.height,
      ))
    }

    for (let i = 0; i < INITIAL_FOOD; i++) {
      this.spawnFood()
    }
  }

  update(dt: number): void {
    this.tick++

    // 各生物を更新
    for (const org of this.organisms) {
      if (org.alive) {
        org.update(dt, this.foods, this.organisms, this.width, this.height)
      }
    }

    // 死体を除去
    this.organisms = this.organisms.filter(o => o.alive)
    this.foods = this.foods.filter(f => f.alive)

    // 繁殖
    const toAdd: Organism[] = []
    for (const org of this.organisms) {
      if (org.energy >= REPRODUCTION_ENERGY) {
        org.energy -= REPRODUCTION_COST
        const offspring = this.reproduce(org)
        toAdd.push(offspring)
      }
    }
    this.organisms.push(...toAdd)

    // 個体数が少なすぎる場合に補充（エコシステム維持）
    if (this.organisms.length < MIN_ORGANISMS) {
      for (let i = 0; i < 5; i++) {
        this.organisms.push(new Organism(
          Math.random() * this.width,
          Math.random() * this.height,
        ))
      }
    }

    // 食料スポーン
    this.foodTimer += dt
    if (this.foodTimer >= FOOD_SPAWN_INTERVAL) {
      this.foodTimer = 0
      if (this.foods.length < MAX_FOOD) {
        const n = Math.floor(Math.random() * 5) + 2
        for (let i = 0; i < n; i++) this.spawnFood()
      }
    }
  }

  private reproduce(parent: Organism): Organism {
    const pt = parent.traits
    const mutate = (v: number, range: number) => v + (Math.random() - 0.5) * range
    const child = new Organism(
      parent.pos.x + (Math.random() - 0.5) * 20,
      parent.pos.y + (Math.random() - 0.5) * 20,
      {
        speed: Math.max(0.3, mutate(pt.speed, 0.4)),
        visionRange: Math.max(20, mutate(pt.visionRange, 10)),
        size: Math.max(2, mutate(pt.size, 1)),
        diet: pt.diet,
        hue: (pt.hue + (Math.random() - 0.5) * 20 + 360) % 360,
        metabolismRate: Math.max(0.5, mutate(pt.metabolismRate, 0.15)),
      },
    )
    return child
  }

  private spawnFood(): void {
    this.foods.push(new Food(
      Math.random() * this.width,
      Math.random() * this.height,
      20 + Math.random() * 20,
    ))
  }

  get stats() {
    return {
      organisms: this.organisms.length,
      foods: this.foods.length,
      tick: this.tick,
    }
  }
}
